import {
    GetPowerBIReportVendasService,
    TypeDashboardBI,
    TypeModulosBIVendas,
} from "../../../Services/Vendas/RelatoriosBI/RelatoriosBIVendasService";
import { Controller } from "../../Controller";

export async function GetPowerBIReportVendasController(
    dsModuloBi: TypeModulosBIVendas,
    dsDashBoardBi: TypeDashboardBI
) {
    return Controller(GetPowerBIReportVendasService(dsModuloBi, dsDashBoardBi));
}
